// UI配置管理
export interface UIConfig {
  colors: {
    primary: string;
    secondary: string;
    success: string;
    warning: string;
    error: string;
    text: string;
    textSecondary: string;
    background: string;
    border: string;
  };
  layout: {
    maxWidth: string;
    borderRadius: string;
    zIndex: {
      header: number;
      modal: number;
      tooltip: number;
      loading: number;
    };
  };
  animation: {
    duration: number;
    easing: string;
  };
}

// 默认UI配置
export const defaultUIConfig: UIConfig = {
  colors: {
    primary: '#1890ff',
    secondary: '#40a9ff',
    success: '#15803d',
    warning: '#ff4d4f',
    error: '#ff7875',
    text: '#2D3436',
    textSecondary: '#6b7280',
    background: '#ffffff',
    border: '#e5e7eb',
  },
  layout: {
    maxWidth: '1200px',
    borderRadius: '9999px',
    zIndex: {
      header: 1000,
      modal: 1000,
      tooltip: 9999,
      loading: 9999,
    },
  },
  animation: {
    duration: 1500,
    easing: 'ease-in-out',
  },
};

// 生产环境UI配置
export const productionUIConfig: UIConfig = {
  ...defaultUIConfig,
  colors: {
    ...defaultUIConfig.colors,
    // 生产环境可以使用更专业的配色
  },
};

// 测试环境UI配置
export const testUIConfig: UIConfig = {
  ...defaultUIConfig,
};

// 获取UI配置
export const getUIConfig = (): UIConfig => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  
  switch (env) {
    case 'production':
      return productionUIConfig;
    case 'test':
      return testUIConfig;
    default:
      return defaultUIConfig;
  }
};

// 导出UI配置实例
export const uiConfig = getUIConfig(); 